var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('h3',[_c('i',{staticClass:"el-icon-document-delete error-icon"}),_c('br'),_vm._v("\n    요청하신 페이지가 존재하지 않습니다\n  ")])])
}]

export { render, staticRenderFns }